import { styled } from "styled-components";
import { useState } from "react";

const FilterButton = styled.button<{ active?: boolean }>`
  padding: 0.5rem 1rem;
  border: 2px solid var(--primary);
  border-radius: 4px;
  background-color: ${props => props.active ? 'var(--primary)' : 'transparent'};
  color: ${props => props.active ? 'white' : 'var(--primary)'};
  font-weight: bold;
  
  &:hover {
    background-color: var(--primary);
    color: white;
  }
`;

const FilterSection = styled.div`
  margin-bottom: 2rem;
  display: flex;
  gap: 1rem;
`;

export type GameFilterValue = 'all' | 'home' | 'away';

type GameFilterProps = {
  filter?: GameFilterValue; // controlled
  onFilterChange?: (next: GameFilterValue) => void;
};

const GameFilter = ({ filter: controlledFilter, onFilterChange }: GameFilterProps) => {
    const [uncontrolledFilter, setUncontrolledFilter] = useState<GameFilterValue>('all');

    const filter = controlledFilter ?? uncontrolledFilter;
    const setFilter = (next: GameFilterValue) => {
      if (controlledFilter === undefined) {
        setUncontrolledFilter(next);
      }
      onFilterChange?.(next);
    };

    return (
        <FilterSection>
            <FilterButton
                active={filter === 'all'}
                onClick={() => setFilter('all')}
            >
                All
            </FilterButton>
            <FilterButton
                active={filter === 'home'}
                onClick={() => setFilter('home')}
            >
                Home
            </FilterButton>
            <FilterButton
                active={filter === 'away'}
                onClick={() => setFilter('away')}
            >
                Away
            </FilterButton>
        </FilterSection>)
}

export default GameFilter;